import { render } from "./switch_client.vue?vue&type=template&id=23650131&scoped=true"
import script from "./switch_client.vue?vue&type=script&lang=js"
export * from "./switch_client.vue?vue&type=script&lang=js"

import "./switch_client.vue?vue&type=style&index=0&id=23650131&scoped=true&lang=css"

import exportComponent from "/var/www/html/fms_employee_Portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23650131"]])

export default __exports__